<template>
  <div>
    <Row typw="flex">
      <Col flex="1">
      <Card class="card-container" dis-hover>
        <div slot="title" class="card-title">{{ getTranslation('k360') }}</div>
        <Row class="limit-line table-row-odd" type="flex">
          <Col flex="1" class="left-program desc-field">{{ getTranslation('k361') }}
          </Col>
          <Col flex="1">
          <Select :transfer="true" v-model="info.OptGunNumSet" class="limit-field" :placeholder="getTranslation('m034')"
            :not-found-text="getTranslation('b038')">
            <Option v-for="(item, key) in OptGunNumSetList" :value="key" :key="key">{{ item }}</Option>
          </Select>
          </Col>
          <template v-if="OptMachineType!=1">
          <Col flex="1" class="left-program desc-field">{{ getTranslation('k365') }}
          </Col>
          <Col flex="1">
          <Select :transfer="true" v-model="info.OptBigOpenFunc" class="limit-field"
            :placeholder="getTranslation('m034')" :not-found-text="getTranslation('b038')">
            <Option v-for="(item, key) in OptBigOpenFuncList" :value="key" :key="key">{{ item }}</Option>
          </Select>
          </Col>
          <Col flex="1" class="left-program desc-field">{{ getTranslation('k368') }}
          </Col>
          <Col flex="1">
          <Select :transfer="true" v-model="info.OptPowerOffElectArmStatus" class="limit-field"
            :placeholder="getTranslation('m034')" :not-found-text="getTranslation('b038')">
            <Option v-for="(item, key) in OptPowerOffElectArmStatusList" :value="key" :key="key">{{ item }}</Option>
          </Select>
          </Col>
          </template>
          <template v-else>
          <Col flex="4" >
          </Col>
          </template>
          
        </Row>
        <template v-if="OptMachineType!=1">
        <Row class="limit-line" type="flex">
          <Col flex="1" class="left-program desc-field">{{ getTranslation('k371') }}
          </Col>
          <Col flex="1">
          <Select :transfer="true" v-model="info.OptBigOpenValveType" class="limit-field"
            :placeholder="getTranslation('m034')" :not-found-text="getTranslation('b038')">
            <Option v-for="(item, key) in OptBigOpenValveTypeList" :value="key" :key="key">{{ item }}</Option>
          </Select>
          </Col>
          <Col flex="1" class="left-program desc-field">{{ getTranslation('k374') }}
          </Col>
          <Col flex="1">
          <Input type="number" v-model="info.OptSmallOpenDelayTime" class="limit-field"></Input>&nbsp;ms
          </Col>
          <Col flex="1" class="left-program desc-field">{{ getTranslation('k375') }}
          </Col>
          <Col flex="1">
          <Select :transfer="true" v-model="info.OptWaterLowAllowWeld" class="limit-field"
            :placeholder="getTranslation('m034')" :not-found-text="getTranslation('b038')">
            <Option v-for="(item, key) in SwitchList" :value="key" :key="key">{{ item }}</Option>
          </Select>
          </Col>
        </Row>
        <Row class="limit-line table-row-odd" type="flex">
          <Col flex="1" class="left-program desc-field">{{ getTranslation('k376') }}
          </Col>
          <Col flex="1">
          <Select :transfer="true" v-model="info.OptGun2WaterFlowFunc" class="limit-field"
            :placeholder="getTranslation('m034')" :not-found-text="getTranslation('b038')">
            <Option v-for="(item, key) in SwitchList" :value="key" :key="key">{{ item }}</Option>
          </Select>
          </Col>
          <Col flex="4">
          </Col>
        </Row>
        </template>
      </Card>
      </Col>
    </Row>
    <div class="menu-actions">
      <Button type="primary" size="small" icon="md-download" @click.native="downloadSystem()">{{ getTranslation('k023')
        }}</Button>&nbsp;
    </div>
  </div>
</template>
<script>
import { API_URL } from '@/constants/const';
import axios from 'axios';
import { Card, Row, Col, Select, Option, Input, Button } from "view-design"
import { mapGetters } from 'vuex'
import { postJsError } from '@/util/util.js'
export default {
  name: 'CalibrationOne', // 组件名称
  components: {
    Card, Row, Col, Select, Option, Input, Button
  },
  props: {
    kind: {
      type: Number,
      default: 803
    },
    OptMachineType: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      info: {},
    }
  },
  computed: {
    ...mapGetters(['getTranslation']),
    OptGunNumSetList() {
      return [
        this.getTranslation("k362"),
        this.getTranslation("k363"),
        this.getTranslation("k364"),
      ]
    },
    OptBigOpenFuncList() {
      return [
        this.getTranslation("k366"),
        this.getTranslation("k367"),
      ]
    },
    OptPowerOffElectArmStatusList() {
      return [
        this.getTranslation("k369"),
        this.getTranslation("k370"),
      ]
    },
    OptBigOpenValveTypeList() {
      return [
        this.getTranslation("k372"),
        this.getTranslation("k373"),
      ]
    },
    SwitchList() {
      return [
        this.getTranslation("k048"),
        this.getTranslation("k049"),
      ]
    },
  },
  watch: {

  },

  created() {
    this.init();
  },
  methods: {
    init() {
      let url = API_URL["systemWeldingInfo"];
      this.mac = this.$route.query.mac
      if (!this.mac) {
        this.$Message.error(this.getTranslation('m041'));
        return
      }
      let params = {
        mac: this.mac
      }
      axios.get(url, {
        params: params
      })
        .then(res => {
          if (res && res.data && res.data.code == 200) {
            this.info = res.data.data;

          } else if (res && res.data && res.data.msg) {
            this.$Message.error(res.data.msg);
          }
        })
        .catch((err) => {
          postJsError(err)
          this.$Message.error(this.getTranslation('c001'));
        })
    },
    downloadSystem() {
      let url = API_URL["systemWeldingDownload"] + '?mac=' + this.mac
      let params = new FormData();
      this.info && Object.keys(this.info).forEach(key => {
        params.append(key, this.info[key]);
      });
      axios.post(url,
        params
      )
        .then(res => {
          if (res && res.data && res.data.code == 200) {
            this.$Message.success(res.data.msg);
          } else if (res && res.data && res.data.msg) {
            this.$Message.error(res.data.msg);
          }
        })
        .catch((err) => {
          postJsError(err)
          this.$Message.error(this.getTranslation('c001'));
        })
    }

  },

}
</script>

<style scoped>
@import url('../../../assets/style/list.css');
@import url('../../../assets/style/tab.css');

/* 卡片内部边框 */
.limit-field {
  width: 80%
}
</style>